import { useQuery } from '@tanstack/react-query';
import { fetchWithError } from "src/react-query/fetchWithError";
import { queryKeys } from 'src/react-query/queryKeys';

const useDropdown = (type, params = null, onLoad = true) => {
    const { data, error, isLoading } = useQuery(queryKeys.getDropdownValues(type, params), fetchWithError, { enabled: onLoad });
    return {
        data: data?.data || [],
        error,
        isLoading,
    };
};

export { useDropdown };